module.exports = __webpack_public_path__ + "img/1191.4299d332.gif";